import type { TranslationCatalog } from "../TranslationManager";

export const de: TranslationCatalog = {
  "labels.cardNumber": "Kartennummer",
  "labels.expirationDate": "Ablaufdatum",
  "labels.cvc": "Sicherheitscode",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "MM / JJ",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "Ihre Kartennummer ist ungültig.",
  "errors.invalidExpiryDate": "Das Ablaufdatum Ihrer Karte ist ungültig.",
  "errors.invalidCvc": "Der Sicherheitscode Ihrer Karte ist ungültig.",
  "errors.incompleteCardNumber": "Ihre Kartennummer ist unvollständig.",
  "errors.incompleteExpiryDate": "Das Ablaufdatum Ihrer Karte ist unvollständig.",
  "errors.incompleteCvc": "Der Sicherheitscode Ihrer Karte ist unvollständig.",
  "errors.expiredCard": "Ihre Karte ist abgelaufen.",
  "aria.cardNumber": "Kartennummer",
  "aria.expirationDate": "Ablaufdatum",
  "aria.cvc": "Sicherheitscode",
  "aria.cardInput": "Karteninformationen",
};
